import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { GetUserSubscriptionsResponse, growthSdk } from '@fff-web/growth-sdk';
import GlobalNavInternalContext from '../context/GlobalNavInternalContext';

export type SubscriptionStatus = 'EXPIRED' | 'ACTIVE' | 'CANCELED';

export const useUserSubscriptions = () => {
  const { env } = useContext(GlobalNavInternalContext);

  const growthSdkInstance = useMemo(() => {
    return growthSdk(env.REACT_APP_ENVIRONMENT as Parameters<typeof growthSdk>[0], true);
  }, [env.REACT_APP_ENVIRONMENT]);

  const [clubMembershipSubscription, setClubMembershipSubscription] =
    useState<GetUserSubscriptionsResponse['subscriptions'][number]>();

  const [boxSubscription, setBoxSubscription] =
    useState<GetUserSubscriptionsResponse['subscriptions'][number]>();

  const fetchUserSubscriptions = useCallback(async () => {
    const response = await growthSdkInstance.getUserSubscriptions();

    if (!response.ok) return;

    const clubMembershipSub = response.data.subscriptions.find((sub) => sub.type === 'MEMBERSHIP');

    const boxSub = response.data.subscriptions.find((sub) => sub.type === 'BOX');

    if (!clubMembershipSub && !boxSub) return;

    if (clubMembershipSub) {
      setClubMembershipSubscription({
        ...clubMembershipSub,
        status: (clubMembershipSub.status === 'NON_RENEWING' ? 'CANCELED' : clubMembershipSub.status) as SubscriptionStatus,
      });
    }

    if (boxSub) {
      setBoxSubscription({
        ...boxSub,
        status: (boxSub.status === 'NON_RENEWING' ? 'CANCELED' : boxSub.status) as SubscriptionStatus,
      });
    }
  }, [growthSdkInstance]);

  useEffect(() => {
    fetchUserSubscriptions();
  }, [fetchUserSubscriptions]);

  return {
    clubMembershipSubscription,
    boxSubscription,
    refetch: fetchUserSubscriptions,
  };
};
